import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import LayoutTable from '../3modules/Layouts/LayoutTable'
import useLayoutConfiguration from '../../services/configPage/useLayoutsConfiguration'

const LayoutConfiguration = () => {
  const {
    onEditMode,
    setOnEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isLoading,
    setIsLoading,
  } = useConfiguration()

  const {
    selectedObjectType,
    setSelectedObjectType,
    layouts,
    handleRowSelect,
    handleCreateNewLayout,
    handleDeleteLayout, 
  } = useLayoutConfiguration(setIsLoading, setIsSnackbarOpen)

  return (
    <ConfigurationWrapper
      header={'Layout Configuration'}
      onEditMode={onEditMode}
      setOnEditMode={setOnEditMode}
      isSnackbarOpen={isSnackbarOpen}
      setIsSnackbarOpen={setIsSnackbarOpen}
      isLoading={isLoading}
      hideSaveCancel
    >
      <LayoutTable
        selectedObjectType={selectedObjectType}
        setSelectedObjectType={setSelectedObjectType}
        layouts={layouts}
        onRowSelect={handleRowSelect}
        onCreateNewLayout={handleCreateNewLayout}
        onDeleteLayout={handleDeleteLayout}    
        onEditMode={onEditMode}                
      />
    </ConfigurationWrapper>
  )
}

export default LayoutConfiguration
